export const textSizes = {
  "2xl": "text-2xl leading-8",
  base: "text-base leading-6",
  lg: "text-lg leading-7",
  sm: "text-sm leading-5",
  xl: "text-xl leading-8",
  xs: "text-xs leading-4",
} as const;

export const textColors = {
  default: "text-neutral-900 dark:text-neutral-50",
  emerald: "text-emerald-500 dark:text-emerald-400",
  muted: "text-zinc-500 dark:text-zinc-400",
} as const;

type TextSize = keyof typeof textSizes;
type TextColor = keyof typeof textColors;

export interface TypographyProps {
  className?: string;
  color?: TextColor;
  size?: TextSize;
}
